import script from "./GoogleAccountSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleAccountSelector.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleAccountSelector.vue?vue&type=style&index=0&id=89d2fdcc&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d2fdcc"]])

export default __exports__